module.exports = __webpack_public_path__ + "img/Flag_of_Kuwait.0887d994.svg";